import React, { useState, useEffect } from "react";
import { purchaseApprovalService } from "../purchaseApprovalService";
import { usePurchaseApprovalModel } from "../purchaseApprovalModel";
import { IPurchaseApprovalFields } from "../purchaseApprovalType";
import { momentFormat } from '@/utils/utils';
import useGlobalModel from "@/model/globalModel";

interface PropsType {
  printVisible: boolean;
  setPrintVisible: (visible: boolean) => void
}

export const PurchaseTable = (props: PropsType) => {
  const { printVisible, setPrintVisible } = props;
  const { descRows } = usePurchaseApprovalModel();
  const [groupedData, setGroupedData] = useState<IPurchaseApprovalFields[][]>([]);
  const { shopAndOrg: { shopCode, shopName } } = useGlobalModel()
  useEffect(() => {
    if (printVisible) {
      const codes = descRows.map(e => e.code);
      purchaseApprovalService.findDetailByCodes(codes).then((res: any) => {
        const list = res.retData;
        // 根据codes数组对数据进行分组
        const groups = codes.map(code =>
          list.filter((item: IPurchaseApprovalFields) => item.code === code)
        );
        setGroupedData(groups);
        print();
      });
    }
  }, [printVisible]);

  const print = () => {
    const el: HTMLElement | null = document.getElementById('offerPrint-container');
    const iframe: HTMLIFrameElement = document.createElement('iframe');
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow?.document;
    if (doc) {
      doc.open();
      // 引入打印样式
      doc.write('<link rel="stylesheet" type="text/css" href="./offerPrint.css">');
      // 写入内容
      doc.write(el?.innerHTML || '');
      doc.close();
    }

    // 监听打印对话框关闭事件
    iframe.contentWindow?.addEventListener('afterprint', () => {
      // 清理iframe
      document.body.removeChild(iframe);
      setPrintVisible(false);
    });

    // 聚焦并触发打印
    iframe.contentWindow?.focus();
    iframe.onload = () => {
      iframe.contentWindow?.print();
    };

    // 兼容旧版IE（通常无法监听afterprint）
    if (navigator.userAgent.indexOf("MSIE") > 0) {
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 100);
    }
  };

  return (
    <div style={{ display: 'none' }}>
      <div id="offerPrint-container" className="offerPrint-container">
        {groupedData.map((group, groupIndex) => {
          // 分页功能：将数据按20行每页分割
          const chunkSize = 20;
          const chunkedData: any = [];
          for (let i = 0; i < group.length; i += chunkSize) {
            chunkedData.push(group.slice(i, i + chunkSize));
          }
          const descRow = descRows.find(item => item.code === group[0]?.code);

          return chunkedData.map((chunk: any, pageIndex: any) => (
            // 每个页面都是独立的，从标题开始
            <div key={`${groupIndex}-${pageIndex}`} className="print-page" style={{ pageBreakAfter: 'always' }}>
              {/* 每页都显示标题 */}
              <div style={{ textAlign: 'center', fontSize: 24, fontFamily: "FangSong", fontWeight: 'normal', margin: "13px 0px" }}>
                {`${shopName}采购审批表`}
              </div>

              {/* 页面信息区域 */}
              <div style={{ marginTop: 10 }}>
                <span style={{ fontSize: 12, fontFamily: "FangSong", fontWeight: 'normal' }}>填报部门：{descRow?.orgName}-{descRow?.shopName}</span>
                <span style={{ marginLeft: 20, fontSize: 12, fontFamily: "FangSong", fontWeight: 'normal' }}>对接人及电话：{descRow?.contact}({descRow?.phone})</span>
                <span style={{ fontSize: 12, fontFamily: "FangSong", fontWeight: 'normal', float: 'right' }}>填制日期：{descRow?.createTime == undefined ? "" : momentFormat(descRow?.createTime)}</span>
              </div>
              <div style={{ marginTop: 5, marginBottom: 5 }}>
                <span style={{ fontSize: 12, fontFamily: "FangSong", fontWeight: 'normal' }}>审批单号：{descRow?.code}</span>
              </div>

              {/* 表格内容 - 每页严格20行数据 */}
              <table className="mingxi" style={{ border: "1px solid black", borderCollapse: 'collapse', width: '100%' }}>
                <thead>
                  <tr style={{ lineHeight: 3.0 }}> {/* 增加表头行高 */}
                    {['序号', '材料编码', '材料名称', '品牌', '适用车型', '规格、型号', '单位', '数量', '用途', '备注'].map((th, i) => (
                      <th key={i} style={{
                        fontSize: 12,
                        fontFamily: "FangSong",
                        fontWeight: 'normal',
                        border: "1px solid black",
                        padding: '2px 5px' /* 增加内边距 */
                      }}>{th}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {/* 数据行 - 最多20行 */}
                  {chunk.map((row: IPurchaseApprovalFields, rowIndex: number) => (
                    <tr key={rowIndex} style={{ lineHeight: 3.0 }}> {/* 增加数据行高 */}
                      <td style={{
                        width: 62,
                        fontSize: 10,
                        fontFamily: "FangSong",
                        fontWeight: 'normal',
                        textAlign: 'center',
                        border: "1px solid black",
                        padding: '2px 5px', /* 增加内边距 */
                        height: '30px' /* 增加单元格高度 */
                      }}>{rowIndex + 1 + pageIndex * chunkSize}</td>
                      <td style={{
                        width: 110,
                        fontSize: 10,
                        fontFamily: "FangSong",
                        fontWeight: 'normal',
                        textAlign: 'center',
                        whiteSpace: 'normal',
                        wordBreak: 'break-all',
                        lineHeight: '1.4', /* 调整内容行高 */
                        height: '30px', /* 增加单元格高度 */
                        border: "1px solid black",
                        padding: '2px 5px' /* 增加内边距 */
                      }}>
                        <div style={{
                          display: '-webkit-box',
                          WebkitBoxOrient: 'vertical',
                          WebkitLineClamp: 2,
                          overflow: 'hidden'
                        }}>{row.materialCode}</div>
                      </td>
                      <td style={{
                        width: 102,
                        fontSize: 10,
                        fontFamily: "FangSong",
                        fontWeight: 'normal',
                        textAlign: 'center',
                        whiteSpace: 'normal',
                        wordBreak: 'break-all',
                        lineHeight: '1.4',
                        height: '30px',
                        border: "1px solid black",
                        padding: '2px 5px'
                      }}>
                        <div style={{
                          display: '-webkit-box',
                          WebkitBoxOrient: 'vertical',
                          WebkitLineClamp: 2,
                          overflow: 'hidden'
                        }}>{row.materialName}</div>
                      </td>
                      <td style={{
                        width: 52,
                        fontSize: 10,
                        fontFamily: "FangSong",
                        fontWeight: 'normal',
                        textAlign: 'center',
                        whiteSpace: 'normal',
                        wordBreak: 'break-all',
                        lineHeight: '1.4',
                        height: '30px',
                        border: "1px solid black",
                        padding: '2px 5px'
                      }}>
                        <div style={{
                          display: '-webkit-box',
                          WebkitBoxOrient: 'vertical',
                          WebkitLineClamp: 2,
                          overflow: 'hidden'
                        }}>{row.brandCode ? row.brandName : ''}</div>
                      </td>
                      <td style={{
                        width: 92,
                        fontSize: 10,
                        fontFamily: "FangSong",
                        fontWeight: 'normal',
                        textAlign: 'center',
                        whiteSpace: 'normal',
                        wordBreak: 'break-all',
                        lineHeight: '1.4',
                        height: '30px',
                        border: "1px solid black",
                        padding: '2px 5px'
                      }}>
                        <div style={{
                          display: '-webkit-box',
                          WebkitBoxOrient: 'vertical',
                          WebkitLineClamp: 2,
                          overflow: 'hidden'
                        }}>{row.vehicleModel}</div>
                      </td>
                      <td style={{
                        width: 122,
                        fontSize: 10,
                        fontFamily: "FangSong",
                        fontWeight: 'normal',
                        textAlign: 'center',
                        whiteSpace: 'normal',
                        wordBreak: 'break-all',
                        lineHeight: '1.4',
                        height: '30px',
                        border: "1px solid black",
                        padding: '2px 5px'
                      }}>
                        <div style={{
                          display: '-webkit-box',
                          WebkitBoxOrient: 'vertical',
                          WebkitLineClamp: 2,
                          overflow: 'hidden'
                        }}>{row.model}</div>
                      </td>
                      <td style={{
                        width: 42,
                        fontSize: 10,
                        fontFamily: "FangSong",
                        fontWeight: 'normal',
                        textAlign: 'center',
                        whiteSpace: 'normal',
                        wordBreak: 'break-all',
                        lineHeight: '1.4',
                        height: '30px',
                        border: "1px solid black",
                        padding: '2px 5px'
                      }}>
                        <div style={{
                          display: '-webkit-box',
                          WebkitBoxOrient: 'vertical',
                          WebkitLineClamp: 2,
                          overflow: 'hidden'
                        }}>{row.unitCode ? row.unitName : ''}</div>
                      </td>
                      <td style={{
                        width: 42,
                        fontSize: 10,
                        fontFamily: "FangSong",
                        fontWeight: 'normal',
                        textAlign: 'center',
                        whiteSpace: 'normal',
                        wordBreak: 'break-all',
                        lineHeight: '1.4',
                        height: '30px',
                        border: "1px solid black",
                        padding: '2px 5px'
                      }}>
                        <div style={{
                          display: '-webkit-box',
                          WebkitBoxOrient: 'vertical',
                          WebkitLineClamp: 2,
                          overflow: 'hidden'
                        }}>{row.confirmNum}</div>
                      </td>
                      <td style={{
                        width: 62,
                        fontSize: 10,
                        fontFamily: "FangSong",
                        fontWeight: 'normal',
                        textAlign: 'center',
                        whiteSpace: 'normal',
                        wordBreak: 'break-all',
                        lineHeight: '1.4',
                        height: '30px',
                        border: "1px solid black",
                        padding: '2px 5px'
                      }}>
                        <div style={{
                          display: '-webkit-box',
                          WebkitBoxOrient: 'vertical',
                          WebkitLineClamp: 2,
                          overflow: 'hidden'
                        }}>{row.purpose}</div>
                      </td>
                      <td style={{
                        width: 72,
                        fontSize: 10,
                        fontFamily: "FangSong",
                        fontWeight: 'normal',
                        textAlign: 'center',
                        whiteSpace: 'normal',
                        wordBreak: 'break-all',
                        lineHeight: '1.4',
                        height: '30px',
                        border: "1px solid black",
                        padding: '2px 5px'
                      }}>
                        <div style={{
                          display: '-webkit-box',
                          WebkitBoxOrient: 'vertical',
                          WebkitLineClamp: 2,
                          overflow: 'hidden'
                        }}>{row.note}</div>
                      </td>
                    </tr>
                  ))}

                  {/* 补充空白行，确保每页正好20行数据 */}
                  {Array.from({
                    length: Math.max(20 - chunk.length, 0)
                  }).map((_, i) => (
                    <tr key={`empty-${i}`} style={{ lineHeight: 3.0 }}> {/* 增加空白行高 */}
                      <td style={{
                        width: 62,
                        fontSize: 10,
                        fontFamily: "FangSong",
                        fontWeight: 'normal',
                        textAlign: 'center',
                        border: "1px solid black",
                        padding: '2px 5px',
                        height: '30px'
                      }}>
                        {chunk.length + i + 1 + pageIndex * chunkSize}
                      </td>
                      {Array(9).fill(null).map((_, i) => (
                        <td key={i} style={{
                          fontSize: 10,
                          fontFamily: "FangSong",
                          fontWeight: 'normal',
                          textAlign: 'center',
                          border: "1px solid black",
                          padding: '2px 5px',
                          height: '30px'
                        }}>&nbsp;</td>
                      ))}
                    </tr>
                  ))}

                  {/* 底部审批行 - 每页都保留 */}
                  <tr style={{ lineHeight: 2.2 }}> {/* 增加审批行高 */}
                    <td colSpan={11} style={{
                      fontSize: 14,
                      fontFamily: "FangSong",
                      fontWeight: 'normal',
                      textAlign: 'left',
                      border: "1px solid black",
                      padding: '8px 10px' /* 增加内边距 */
                    }}>
                      填报人：　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　年　　月　　日
                    </td>
                  </tr>
                  <tr style={{ lineHeight: 2.2 }}>
                    <td colSpan={11} style={{
                      fontSize: 14,
                      fontFamily: "FangSong",
                      fontWeight: 'normal',
                      textAlign: 'left',
                      border: "1px solid black",
                      padding: '8px 10px'
                    }}>
                      采购管理部负责人：　　　　　　　　　　　　　　　　　　　　　　　　　　　　年　　月　　日
                    </td>
                  </tr>
                  <tr style={{ lineHeight: 2.2 }}>
                    <td colSpan={11} style={{
                      fontSize: 14,
                      fontFamily: "FangSong",
                      fontWeight: 'normal',
                      textAlign: 'left',
                      border: "1px solid black",
                      padding: '8px 10px'
                    }}>
                      主管领导：　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　年　　月　　日
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          ));
        })}
      </div>
    </div>
  );
};
